import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import react from 'react';
import axios from 'axios';
import {host} from '../../function/api'

const initialState = {
    loading: false,
    success: false,
    message: '', 
    archives: [],
    errorArchives: '',
    errorName: '',
    errorManager: '',
    errorCode: '',
    errorPhone: '',
    errorAddress: '',
    rahpardaznetLoading: '',
    rahpardaznetSuccess: false,
    rahpardaznetMessage: '',
}

export const archiveSave = createAsyncThunk(
    'archive/save',
    async(data, thunkAPI) => {
        try {
            const response = await axios({
            method: 'POST',
            url: `${host}store`,
            data: data,
            headers: {
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            return await response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)

export const archiveIndex = createAsyncThunk(
    'archive/index',
    async(data, thunkAPI) => {
        try {
            let UrlApi = data.countPerPage ? `${host}store?page=${data.pageNumber}&per_page=${data.countPerPage}&search=${data.search}&delay=1` : `${host}store`

            const response = await axios({
                method: 'GET',
                url: UrlApi,
                headers:{
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            return await response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)
export const fetchArchiveUser = createAsyncThunk(
    'fetch/archiveUserPermission',
    async(data, thunkAPI) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}store/user`,
                data: data,
                headers:{
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            return await response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)
const archiveSlice = createSlice({
    name: 'archive',
    initialState,
    reducers: {

    },
    extraReducers: {
        [archiveSave.fulfilled]: (state,{ payload }) => {
            state.rahpardaznetLoading = false;
            state.rahpardaznetSuccess = true;
            state.rahpardaznetMessage = payload.message;
        },
        [archiveSave.pending]: (state) => {
            state.rahpardaznetLoading= true;
            state.rahpardaznetSuccess = false;
            state.rahpardaznetMessage = "";
            state.errorName = "";
            state.errorManager = "";
            state.errorCode = "";
            state.errorPhone = "";
            state.errorAddress = "";
        },
        [archiveSave.rejected]: (state, { payload }) => {
            state.rahpardaznetLoading = false;
            state.rahpardaznetSuccess = false;
            
            if(payload.response.data.error) {
                state.errorName = payload.response.data.error.name
                state.errorManager = payload.response.data.error.manager
                state.errorCode = payload.response.data.error.code
                state.errorPhone = payload.response.data.error.phone
                state.errorAddress = payload.response.data.error.address
            }else{
                state.rahpardaznetMessage = payload.response.data.message;
            }
        },
        [archiveIndex.fulfilled]: (state, action) => {
            state.loading = false;
            state.rahpardaznetLoading = false;
            state.success = true;
            state.archives = action.payload.data
        },
        [archiveIndex.pending]: (state) => {
            state.loading = true;
            state.rahpardaznetLoading = true;
        },
        [archiveIndex.rejected]: (state, { payload }) => {
            state.loading = false;
            state.rahpardaznetLoading = false;
            state.success = false;
            if(payload.response.data.error){
                state.error = payload.response.data.error
            } else if (payload.response.data.message) {
                state.message = payload.response.data.message
            }
        },
        [fetchArchiveUser.fulfilled]: (state, action) => {
            state.loading = false;
            state.success = true;
            state.archives = action.payload.data
        },
        [fetchArchiveUser.pending]: (state) => {
            state.loading = true;
            state.archives = [];
        },
        [fetchArchiveUser.rejected]: (state, { payload }) => {
            state.loading = false;
            state.success = false;
            if(payload.response.data.error){
                state.error = payload.response.data.error
            } else if (payload.response.data.message) {
                state.message = payload.response.data.message
            }
        }
    }
})

export const {} = archiveSlice.actions;
export default archiveSlice.reducer;